import { PiLockSimpleBold } from "react-icons/pi";

const ConflictChoice = ({ conflict, onChoose }) => (
  <div
    role="radiogroup"
    className="overflow-hidden rounded-md bg-white text-[13px] shadow-[0_1px_2px_rgba(16,24,40,0.04)] ring-1 ring-gray-200"
    title={
      conflict.isLocked
        ? `Identité conservée depuis la fiche patient (dossier : ${conflict.current || "vide"})`
        : `Dossier en cours : ${conflict.current || "vide"} · Fiche patient : ${conflict.db}`
    }
  >
    {[
      ["dossier", "Dossier", conflict.current],
      ["fiche", "Fiche", conflict.db],
    ].map(([value, caption, text]) => {
      const checked = conflict.choice === value;
      const discarded = conflict.choice !== undefined && !checked;
      return (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={checked}
          disabled={conflict.isLocked}
          onClick={() => onChoose(conflict.key, value)}
          title={text || "vide"}
          className={`group flex min-h-[28px] w-full min-w-0 items-center gap-2 py-1 pl-2.5 pr-2 text-left transition-colors disabled:cursor-default ${
            value === "fiche" ? "border-t border-gray-100" : ""
          } ${checked ? "bg-gray-50" : "hover:bg-gray-50"}`}
        >
          <span
            className={`flex h-[14px] w-[14px] shrink-0 items-center justify-center rounded-full transition-all ${
              checked ? "bg-primary-500" : "bg-white ring-[1.5px] ring-inset ring-gray-300 group-hover:ring-gray-400"
            }`}
          >
            {checked && <span className="h-[5px] w-[5px] rounded-full bg-white" />}
          </span>
          <span className={`w-[42px] shrink-0 text-[11px] ${checked ? "text-gray-500" : "text-gray-400"}`}>{caption}</span>
          <span
            className={`line-clamp-2 min-w-0 flex-1 leading-[18px] [overflow-wrap:anywhere] ${checked ? "font-medium text-gray-900" : discarded ? "text-gray-400" : "text-gray-700"} ${text ? "" : "italic"}`}
          >
            {text || "vide"}
          </span>
          {conflict.isLocked && value === "fiche" && <PiLockSimpleBold className="h-3 w-3 shrink-0 text-gray-400" />}
        </button>
      );
    })}
  </div>
);

export default ConflictChoice;
